
import * as XLSX from 'xlsx';
import TimeStamp from "../../timeStamp"; // import xls to json

export default class EXCEL_DOWNLOAD{

    static exportJsonList(spielerList, sheetName, fileTimeStamp) {
        console.log ("spielerList", spielerList);
        EXCEL_DOWNLOAD.downloadToExcel(spielerList, sheetName, fileTimeStamp)
    }

    static downloadToExcel (spielerList, sheetName, fileTimeStamp) {
        let sheets = ['Neuanmeldungen', 'Ummeldung', 'Ummeld. aus a. LV', 'Wiederanmeldung',
                     'Duplikat', 'Namens- u. Div.Änderungen', 'Abgelaufene Pässe', 'Abmeldungen'];
        //let exportSet = this.spezTranslation(this.list);
        //let ws = XLSX.utils.json_to_sheet(spielerList, {header: this.header});
        let ws = XLSX.utils.json_to_sheet(spielerList);
        let wb = XLSX.utils.book_new();
        if ( sheetName === 'Fehlende Dokumente' ) {
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        } else if ( sheetName === 'ADE-Arzt' ) {
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        } else {
            sheets.forEach( (sheet) => {
                XLSX.utils.book_append_sheet(wb, sheet === sheetName ? ws : null, sheet);
            });
        }
        const timeStamp = fileTimeStamp ? fileTimeStamp : TimeStamp.getFileTimeStamp();
        let exportFileName = sheetName + '_' + timeStamp + '.xlsx';
        XLSX.writeFile(wb, exportFileName);
    }

}